import axios from "axios";
import { METODOS_ES } from "../constants/service-resources";
import IMetodoES from "../interfaces/service/models/IMetodoES";

export async function getMeotdosEs(){
    const result = await axios.get<IMetodoES[]>(METODOS_ES)
    return result.data
}